<template>
  <div class="smaller-container-wrapper full-height">
    <div class="row">
      <div class="col-sm-8">
        <h2>{{ $t('message.eCommerceV2.credit.intro.heading') }}</h2>
        <p class="text-dark mb-4">
          {{
            $t('message.eCommerceV2.credit.intro.msg', { creditProvider: getDefaultCreditDataSourceCAName.niceName })
          }}
        </p>
        <ul class="list-unstyled pb-1 pt-1">
          <li class="mb-4" v-for="(item, index) in list" :key="index">
            <span class="primary-fill-svg">
              <inline-svg class="mr-2 mb-1" :src="require('@/assets/check-circle-blue-fill.svg')" alt="" />
            </span>
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="col-sm-4">
        <div class="avr-card px-3 pb-3 pt-1">
          <img
            class="tu-logo"
            :src="require(`@/assets/credit-bureaus/${getDefaultCreditDataSourceCAName.logoName}`)"
            :alt="getDefaultCreditDataSourceCAName.niceName"
          />
          <p class="small mb-1 mt-0">
            {{
              $t('message.eCommerceV2.credit.intro.creditProvider', {
                creditProvider: getDefaultCreditDataSourceCAName.niceName,
              })
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="push-down-desktop">
      <mobialis-button
        @click="next"
        class="mt-5 mb-3"
        data-cy="continue"
        v-av-analytics-cta-interaction="{ elementText: $t('message.common.continue'), eventActionResult: 'open' }"
        >{{ $t('message.common.continue') }}</mobialis-button
      >
      <p v-if="isEquifax" class="mt-0 font-size-10 color-primary-grey">{{ $t('message.credit.disclaimer.equifax') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CreditDataSourceCA } from '@/utils/enums';

export default {
  name: 'CreditIntro',
  data() {
    return {
      list: this.$t('message.eCommerceV2.credit.intro.list'),
    };
  },
  computed: {
    ...mapGetters('ecommerceV2', ['getDefaultCreditDataSourceCAName']),
    ...mapGetters('business', ['getDefaultCreditDataSourceCA']),
    isEquifax() {
      return this.getDefaultCreditDataSourceCA === CreditDataSourceCA.EQUIFAX;
    },
  },
  methods: {
    next() {
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.tu-logo {
  width: 108px;
  height: 61px;
}
</style>
